import {
  InputWrapper,
  StyledSelect,
  StyledTextarea,
} from "../../StyleField/StyleFields";
import { ErrorText } from "../../StyleField/StyleFields";
import { StyledTextField } from "../../StyleField/StyleFields";
import { FieldContainer, FieldLabel } from "../../StyleField/StyleFields";
import { Avatar, Box, MenuItem, SelectChangeEvent, Stack } from "@mui/material";
import React, { useState } from "react";
import ImageUpload from "../../common/ImageUpload";
import { useGetCategories } from "../../../services/api/card.api";
import { CategoriesValue } from "../../../types/Card";

type GenralInfoFormProps = {
  values: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  setFieldValue: (field: string, value: any) => void;
};

const GenralInfoForm = ({
  values,
  handleChange,
  errors,
  setFieldValue,
}: GenralInfoFormProps) => {
  const [profilePreview, setProfilePreview] = useState<string | null>(
    values?.profile_image || null
  );
  const [coverPreview, setCoverPreview] = useState<string | null>(
    values?.cover_image || null
  );

  const { data: categories } = useGetCategories({ key: ["categories"] });
  const categoryList: CategoriesValue[] = categories?.data || [];

  return (
    <div>
      {/* Profile Upload */}
      <FieldContainer>
        <FieldLabel>Profile Picture</FieldLabel>
        <Stack direction={{ xs: "column", md: "row" }} gap={2}>
          <Avatar
            sx={{ width: 40, height: 40, borderRadius: "8px" }}
            src={profilePreview ?? "/assets/Upstream.png"}
          />
          <Box sx={{ flex: 1 }}>
            <ImageUpload
              onFileSelect={(files: FileList | null) => {
                if (files?.[0]) {
                  const file = files[0];
                  setProfilePreview(URL.createObjectURL(file));
                  setFieldValue("profile_image", file);
                }
              }}
              layout="row"
            />
          </Box>
        </Stack>
      </FieldContainer>

      {/* Cover Image Upload */}
      <FieldContainer>
        <FieldLabel>Cover Image</FieldLabel>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: { xs: "120px", sm: "160px", md: "200px" },
            borderRadius: "16px",
            overflow: "hidden",
            mb: 2,
          }}
        >
          <Box
            component="img"
            src={coverPreview || "/assets/default-cover.png"}
            alt="Cover"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
        <ImageUpload
          onFileSelect={(files: FileList | null) => {
            if (files?.[0]) {
              const file = files[0];
              setCoverPreview(URL.createObjectURL(file));
              setFieldValue("cover_image", file);
            }
          }}
          layout="row"
          name="cover_image"
        />
      </FieldContainer>

      {/* Talent Name */}
      <FieldContainer>
        <FieldLabel>Talent Name</FieldLabel>

        <StyledTextField
          name="username"
          placeholder="Talent Name"
          value={values.username}
          onChange={handleChange}
          error={Boolean(errors.username)}
        />

        {errors.username && <ErrorText>{errors.username}</ErrorText>}
      </FieldContainer>

      {/* Category (dropdown) */}
      <FieldContainer>
        <FieldLabel>Select Category</FieldLabel>
        <InputWrapper>
          <StyledSelect
            name="categories"
            value={values.categories}
            onChange={(
              event: SelectChangeEvent<unknown>,
              _: React.ReactNode
            ) => {
              setFieldValue("categories", event.target.value);
            }}
            displayEmpty
            inputProps={{ "aria-label": "Select Category" }}
          >
            <MenuItem sx={{ font: "var(--body-sm)" }} value="">
              <em>Select Category</em>
            </MenuItem>
            {categoryList.map((category) => (
              <MenuItem
                sx={{ font: "var(--body-sm)" }}
                key={category.name}
                value={category.name}
              >
                {category.name}
              </MenuItem>
            ))}
          </StyledSelect>
        </InputWrapper>
        {errors.categories && <ErrorText>{errors.categories}</ErrorText>}
      </FieldContainer>

      {/* Bio */}
      <FieldContainer>
        <Stack direction="row" justifyContent="space-between">
          <FieldLabel>Enter your Bio</FieldLabel>
          <Box
            sx={{
              textAlign: "right",
              mt: 0.5,
              color: "#999",
              fontSize: "12px",
            }}
          >
            {values.bio?.length || 0}/1000
          </Box>
        </Stack>
        <InputWrapper>
          <StyledTextarea
            name="bio"
            multiline
            rows={4}
            placeholder="Some interesting facts about you..."
            value={values.bio}
            onChange={handleChange}
            error={Boolean(errors.bio)}
          />
        </InputWrapper>
        {errors.bio && <ErrorText>{errors.bio}</ErrorText>}
      </FieldContainer>
    </div>
  );
};

export default GenralInfoForm;
